import type { GiveBackTerms } from "../api/types.ts";
import { useI18n } from "../i18n/index.tsx";

/**
 * The step between "Give it back" and the card actually leaving (Arianna,
 * 2026-11-01): the link sits right beside Submit, and "abgeben" reads as both
 * hand in and give back. It says what it is not (a hand-in) and what it costs
 * (the cooldown, the trust), with both numbers from the server.
 */
export function GiveBackConfirm({
  terms,
  busy,
  onConfirm,
  onKeep,
  buttonClass,
  primaryClass,
}: {
  terms: GiveBackTerms | null;
  busy: boolean;
  onConfirm: () => void;
  onKeep: () => void;
  buttonClass: string;
  primaryClass: string;
}) {
  const { t } = useI18n();
  return (
    <div className="give-back-confirm" role="alertdialog" aria-label={t("dashboard.giveBackConfirmTitle")}>
      <p className="give-back-confirm-title">{t("dashboard.giveBackConfirmTitle")}</p>
      {terms && (
        <p className="give-back-confirm-body">
          {t("dashboard.giveBackConfirmBody", { hours: terms.cooldownHours })}{" "}
          {terms.trustCost > 0 ? t("dashboard.giveBackConfirmTrust", { trust: terms.trustCost }) : t("dashboard.giveBackConfirmFree")}
        </p>
      )}
      <div className="give-back-confirm-actions">
        <button type="button" className={primaryClass} disabled={busy} onClick={onKeep}>{t("dashboard.giveBackConfirmKeep")}</button>
        <button type="button" className={buttonClass} disabled={busy} onClick={onConfirm}>
          {busy ? t("dashboard.givingBack") : t("dashboard.giveBackConfirmYes")}
        </button>
      </div>
    </div>
  );
}
